// extracted by mini-css-extract-plugin
module.exports = {"app":"NghkZ-"};